// Quick fix - reapply grid classes after facet updates
document.addEventListener('DOMContentLoaded', function() {
  let currentGrid = 'custom-grid-1';
  
  // Store selection when buttons are clicked
  document.querySelectorAll('.view-icon').forEach(button => {
    button.addEventListener('click', function() {
      currentGrid = this.getAttribute('data-grid');
    });
  });
  
  // Reapply after facet changes
  setInterval(function() {
    const grid = document.getElementById('product-grid');
    if (grid && !grid.classList.contains(currentGrid)) {
      ['custom-grid-1', 'custom-grid-3', 'custom-list-view'].forEach(cls => 
        grid.classList.remove(cls)
      );
      grid.classList.add(currentGrid);
    }
  }, 500);
});